import { AxiosResponse } from 'axios';
import cleanDeep from 'clean-deep';
import { api } from 'tools/api-service';
import { GetNewsRequestParams, GetNewsResponse } from './types';

export const getNews = async (params: GetNewsRequestParams): Promise<
    AxiosResponse<GetNewsResponse>
> => {
    const { lang, tag, page, pageSize } = params;
    const cleanedParams = cleanDeep({
        lang,
        tag,
        page,
        pageSize,
    });

    const response = await api.get('/news', { params: cleanedParams });

    return response;
};
